import * as React from 'react';

export const SelectedIndexContext = React.createContext<number>(
  // This is `undefined` and typecasted on purpose.
  // See https://github.com/DefinitelyTyped/DefinitelyTyped/pull/24509#issuecomment-382213106
  undefined as unknown as number
);

export const OnSelectedIndexChangedContext = React.createContext<(idx: number) => void>(() => {});
